import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiDatabase } from "../../App/API/api";

export const createPatientAction = createAsyncThunk("patient/create", async ({ fullname, gender, birthday, phone, branchId }, { thunkApi }) => {
    try {
        const response = await apiDatabase.post("/create-patient", {
            fullname,
            gender,
            birth_date: birthday,
            phone,
            branch_id: branchId,
            isWeb: true
        });
        const data = response.data.data;
        return data;
    } catch (error) {
        console.log(error.response.data)
        thunkApi.rejectwithValue(error.response.data.message);
        return error;
    }
});

const patientSlice = createSlice({
    name: "patient",
    initialState: {
        loading: false,
        error: null,
        patients: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(createPatientAction.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(createPatientAction.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.patients = action.payload;
        });
        builder.addCase(createPatientAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default patientSlice.reducer;